import React from 'react';
import UsaSelect00 from '../UsaSelect00'
import {cl} from '../../../components/utils/utils';

class RepeatHours extends React.Component{
  constructor(props) {// 
    super(props);
    this.state={
      hours: 1,
    }
    this.repeat=this.props.parms.repeat
  }
  
  onChange=(vals)=>{
//     cl(this.props)
    this.repeat.period=vals.hours
    this.setState(vals)
    this.props.parms.onChange({repeat: Object.assign({},this.repeat)})
  }
  
  render(){
    return(
      <UsaSelect00 parms={{
        title: "Repeat\u00A0Every",
        footer: "Hours",
        footerPlural: true,
        type: "number",
        min: 1,
        width: 50,
        select: false, // !this.state.editMode,
        valueId: "hours",//valueId, // "widgetSel",
        value: this.state.hours, //value, // this.state.widgetSel,
        onChange: this.onChange,
      }}/>
    )
  }
}

export default RepeatHours ;

